<div class="modal-header d-flex justify-content-between">
  <h5 class="modal-title">{{'Time spent' | messageTranslate}}</h5>
  <button type="button" class="btn-close ms-1" [attr.aria-label]="'Close' | messageTranslate" (click)="activeModal.dismiss('Cross click')"></button>
</div>

<div class="modal-body d-flex justify-content-center">
  <app-duration-input [clearable]="clearable"
                      [showLabel]="showLabel"
                      [units]="units"
                      [formControl]="durationControl" />
</div>

<div class="modal-footer d-flex justify-content-end">
  <app-button visual="secondary" label="Cancel" [disabled]="saving" (buttonClick)="activeModal.dismiss('User cancel')" />
  <app-button visual="primary" label="Save" [loading]="saving" (buttonClick)="save()" />
</div>
